const app = {
  fn: {
    run: null,
  },

  lib: {
    i18n: null,
    settings: null,
    token: null,
  },

  run: {
    headers: null,
    i18n: null,
    route: null,
    router: null,
    settings: null,
    token: null,
  }
};

app.fn.run = async () => {
  app.lib.i18n.detect();

  await app.lib.token.run();
  await app.lib.settings.run();

  app.lib.i18n.render();

  app.lib.router(window.location.hash);
  window.addEventListener('hashchange', () => {
    app.lib.router(window.location.hash);
  });

  document.getElementById('app-loader').classList.add('d-none');

  console.log(app);
  /*
  document.title = app.conf.title;


  document.getElementById('app-loader').classList.add('d-none');
  */
};

export default app;
